import { SchemaTypes } from '@allesauto/graphql';
import { isEmptyObject } from '@allesauto/utils/funcs';

import { IParsedQuery } from '../types';

// create filter object to be passed to vehicles query
export const createVehiclesFilterObject: (
  parsedQuery: IParsedQuery,
  modelDropdownHasSubGroups: boolean | undefined | null
) => SchemaTypes.VehicleFilterOptions = (
  parsedQuery: IParsedQuery,
  modelDropdownHasSubGroups: boolean | undefined | null
) => {
  const filters: SchemaTypes.VehicleFilterOptions = {};

  if (Array.isArray(parsedQuery.makeModel)) {
    filters.brands = [];

    parsedQuery.makeModel.forEach((makeModel) => {
      const brandFilter: SchemaTypes.BrandFilter = {};

      if (!isEmptyObject(makeModel.makes)) {
        brandFilter.makeName = makeModel.makes;
      }
      if (!isEmptyObject(makeModel.models) && !modelDropdownHasSubGroups) {
        brandFilter.modelName = makeModel.models;
      } else {
        brandFilter.modelName = ''; // Add an empty model property if we have subgroups
        if (makeModel.modelGroup) {
          filters.modelGroup = makeModel.modelGroup;
        } else {
          filters.modelGroup = makeModel.models;
        }
      }

      if (!isEmptyObject(brandFilter)) filters.brands?.push(brandFilter);
    });
  } else {
    filters.brands = [];
  }

  if (
    !isEmptyObject(parsedQuery.location) &&
    !isEmptyObject(parsedQuery.location.location) &&
    !isEmptyObject(parsedQuery.location.radius) &&
    !isEmptyObject(parsedQuery.location.latitude) &&
    !isEmptyObject(parsedQuery.location.longitude)
  ) {
    filters.location = {
      maxDistance: parsedQuery.location.radius,
      name: parsedQuery.location.location.label,
      latitude: parsedQuery.location.latitude,
      longitude: parsedQuery.location.longitude,
    };
  }

  if (!isEmptyObject(parsedQuery.merchantLocation)) {
    filters.merchantUuids = parsedQuery.merchantLocation.merchantLocation;
  }

  if (!isEmptyObject(parsedQuery.bodyColors)) {
    filters.bodyColors = parsedQuery.bodyColors;
  }

  if (!isEmptyObject(parsedQuery.drive)) {
    filters.drive = parsedQuery.drive;
  }

  if (!isEmptyObject(parsedQuery.interior)) {
    filters.interior = parsedQuery.interior;
  }

  if (!isEmptyObject(parsedQuery.vehicleType)) {
    filters.vehicleType = parsedQuery.vehicleType;
  }

  if (!isEmptyObject(parsedQuery.vehicleCondition)) {
    filters.vehicleCondition = parsedQuery.vehicleCondition;
  }

  if (!isEmptyObject(parsedQuery.equipment)) {
    filters.equipment = parsedQuery.equipment;
  }

  if (!isEmptyObject(parsedQuery.priceRange)) {
    filters.priceRange = parsedQuery.priceRange;
  }

  if (!isEmptyObject(parsedQuery.fuelType)) {
    filters.fuelType = parsedQuery.fuelType;
  }
  if (!isEmptyObject(parsedQuery.emission)) {
    filters.emission = parsedQuery.emission;
  }

  return filters;
};
